import type { FC } from 'react';

import { Textfit } from '@wwe-portal/ui/components/text-fit';

import { cn } from '@wwe-portal/ui/lib/lib';

function IconV2() {
  return (
    <svg
      className="h-full w-full"
      fill="none"
      height={52}
      viewBox="0 0 53 53"
      width={53}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M52.07 28.54c-.345-.571-.708-1.148-.969-1.782-.118-.283-.151-.6-.224-.923-.109-.475.092-1.142.204-1.445.34-.93.736-1.685 1.082-2.615.152-.413.29-1.082.136-1.6-.324-1.079-1.178-1.573-1.986-2.164-.637-.468-1.214-1.068-1.534-1.85-.165-.4-.307-1.56-.181-2.14v-.452c.043-.195.072-1.062.023-1.287-.158-.709-.244-1.138-.61-1.623-.403-.537-1.158-.738-1.87-.97-.192-.062-.37-.049-.564-.111-.937-.3-1.844-.58-2.368-1.287-1.036-1.388-1.155-3.99-2.82-4.713-.63-.274-1.633-.214-2.346-.046-.105.007-.21.017-.316.023-.27.066-.914.168-1.263.09-.59-.133-1.06-.205-1.488-.476-.96-.607-1.504-1.63-2.391-2.299-.594-.448-.976-.874-2.071-.854-.12.076-.334.046-.475.09a4.389 4.389 0 0 0-.881.382c-.577.353-1.151.745-1.804 1.016-.175.072-.327.075-.518.135-.336.102-.96.152-1.352.046-1.04-.28-1.857-.732-2.797-1.128-.356-.148-1.135-.419-1.669-.293-1.399.326-1.926 1.365-2.662 2.345-.402.537-1 .97-1.669 1.24-.379.151-1.533.273-2.074.158h-.452c-.191-.043-1.042-.073-1.263-.023-.749.168-1.125.218-1.646.61-.6.452-.792 1.333-1.036 2.14-.066.225-.062.413-.135.63-.198.6-.425 1.145-.765 1.6-1.052 1.412-3.803 1.356-4.825 2.728-.215.29-.373.633-.475 1.035-.09.36-.053.858.023 1.194l.046.495c.168.696.25 1.768.023 2.457-.65 1.97-2.79 2.464-3.427 4.443-.178.558.01 1.2.181 1.6.386.907.93 1.567 1.287 2.526.105.28.28.907.181 1.352-.082.357-.119.703-.247 1.016-.32.779-.69 1.468-.993 2.276-.195.525-.36 1.352-.112 1.963.373.92 1.17 1.392 1.916 1.939.663.485 1.227 1.095 1.557 1.916.152.38.274 1.534.158 2.075v.452c-.043.191-.072 1.039-.023 1.263.168.749.218 1.125.61 1.646.452.6 1.333.791 2.14 1.035.212.047.423.09.63.136.796.26 1.577.593 2.03 1.194 1.022 1.362 1.12 3.687 2.592 4.6.781.482 2.279.284 3.245.07.62-.139 1.547.046 1.963.224 1.777.772 2.275 2.853 4.33 3.361.525.129 1.059-.082 1.399-.224.907-.386 1.566-.93 2.526-1.286.28-.106.907-.28 1.352-.182.357.082.703.119 1.016.247.779.32 1.468.69 2.276.993.524.198 1.352.36 1.962.112.92-.372 1.392-1.17 1.94-1.916.488-.663 1.095-1.224 1.916-1.557.41-.165 1.478-.28 2.052-.158h.475c.194.043 1.062.073 1.286.023.709-.158 1.138-.244 1.623-.61.6-.452.791-1.333 1.035-2.14.046-.212.09-.423.136-.63.26-.792.593-1.58 1.193-2.029 1.363-1.016 3.691-1.121 4.601-2.592.482-.782.284-2.28.07-3.246-.139-.623.046-1.547.224-1.962.643-1.478 2.206-2.114 3.021-3.427.191-.31.267-.67.36-1.082.132-.587-.33-1.448-.518-1.758v.003Z"
        fill="#FF004C"
        fillRule="evenodd"
      />
    </svg>
  );
}

export const BonusBadge: FC<{ percent: number; className?: string }> = ({
  percent,
  className,
}) => {
  return (
    <div className={cn('inline-flex items-center justify-center', className)}>
      <div className="absolute inset-0">
        <IconV2 />
      </div>
      <div
        className="absolute inset-0 flex flex-col items-stretch justify-center text-sm font-bold text-[#fffbdb]"
        style={{
          transform: 'rotate(-15deg)',
        }}
      >
        <Textfit
          className="w-full px-[20%] text-center text-sm font-bold leading-[21pxv] text-[#fffbdb]"
          max={14}
          mode="single"
        >
          {percent}%
        </Textfit>
        <div className="text-2xs w-full px-[20%] text-center font-semibold capitalize leading-[15px] text-[#fffbdb]">
          BONUS
        </div>
      </div>
    </div>
  );
};
